import { Injectable, inject } from '@angular/core';
import { CommercialOutageBuilderService } from 'src/app/services/builder/commercial-outage-builder.service';
import { Observable } from 'rxjs';
import { queryForCommercialOutages } from 'src/app/graphql/commercial-services/commercial-outages/query-for-commercial-outages';
import {
  CommercialOutageConnection,
  CommercialOutageSortOrQuery,
} from 'src/app/model/commercial-services/commercial-outage';
import { BaseAppSyncService } from '../base-app-sync.service';

@Injectable({
  providedIn: 'root',
})
export class CommercialOutageApiService extends BaseAppSyncService {
  private _commercialOutageBuilder = inject(CommercialOutageBuilderService);

  queryForCommercialOutages(
    limit: number,
    page: number,
    query: CommercialOutageSortOrQuery,
    sort: CommercialOutageSortOrQuery
  ): Observable<CommercialOutageConnection> {
    return this.query(
      queryForCommercialOutages,
      { limit, page, query, sort },
      (i: any) =>
        this._commercialOutageBuilder.buildCommercialOutageConnection(i),
      'queryForCommercialOutages'
    );
  }
}
